export enum MuleVersionEnum {
  Mule3 = "Mule3",
  Mule4 = "Mule4"
}
